import React, { FC, useMemo } from 'react'
import { SensorColumnsDataGrid } from 'src/components/columns/sensor'
import { Sensor, SensorState } from 'src/api'
import { SensorListFilters } from 'src/components/forms/sensor'
import { SensorFilters, SensorButtons } from 'src/enums'
import { CommonSensorList } from '../commonSensorsList'
import { SensorContextMenu, SensorMenuItemKey, useSensorContextMenu, createActionsColumn } from '../sensorContextMenu'

const getColumns = ({ handleOpenMenu }: { handleOpenMenu: (e: any, row: any) => void }) => [
  SensorColumnsDataGrid.Id(),
  SensorColumnsDataGrid.Model,
  SensorColumnsDataGrid.DevEUI,
  SensorColumnsDataGrid.Label,
  SensorColumnsDataGrid.LastPing,
  SensorColumnsDataGrid.SignalStrength,
  SensorColumnsDataGrid.BatteryLevel,
  SensorColumnsDataGrid.DateAdded,
  SensorColumnsDataGrid.LastActiveContractor,
  SensorColumnsDataGrid.Project,
  SensorColumnsDataGrid.State,
  createActionsColumn(handleOpenMenu)
]

interface AllLoRaWanSensorListProps {
  isLoading: boolean
  count: number
  data: Sensor[]
  states: SensorState[]
  refetchSensorList: () => void
}

export const AllLoRaWanSensorList: FC<AllLoRaWanSensorListProps> = ({ data, isLoading, count, states, refetchSensorList }) => {
  const { currentRow, menuAnchorEl, handleOpenMenu, handleCloseMenu } = useSensorContextMenu()
  const dataWithState = useMemo(
    () =>
      data.map((row) => ({
        ...row,
        state: states.find((e) => e.id === row.stateId)
      })),
    [data, states]
  )

  return (
    <>
      <CommonSensorList
        columns={getColumns({ handleOpenMenu })}
        count={count}
        data={dataWithState}
        isLoading={isLoading}
        filters={<SensorListFilters activeFilters={[SensorFilters.LowBattery, SensorFilters.WeakSignal, SensorFilters.LastPingMoreThanHour]} />}
        buttons={[SensorButtons.DownloadLabels]}
      />
      <SensorContextMenu
        menuItems={[SensorMenuItemKey.MarkAsLost, SensorMenuItemKey.MakeAvailable]}
        currentRow={currentRow}
        menuAnchorEl={menuAnchorEl}
        onOpenMenu={handleOpenMenu}
        onCloseMenu={handleCloseMenu}
        states={states}
        refetchSensorList={refetchSensorList}
      />
    </>
  )
}
